import { useQuery } from "@tanstack/react-query";
import { api, ApiError, type AppState } from "../../api";
import type { Bag } from "../../products/types";
import { isEmployeeBag, visibleCard } from "../cards/model";

export const productPath = (id: string) => `product/${encodeURIComponent(id)}`;
export function productScope(user: AppState) { return `${user.user_id ?? user.name}:${!!user.can_finance}:${!!user.can_publish}`; }
export function useProduct<T extends Bag = Bag>(id: string, user: AppState, enabled = true) {
  const allowed = enabled && Boolean(user.can_finance || user.can_publish);
  const query = useQuery<T>({
    queryKey: ["next", productPath(id), productScope(user)],
    queryFn: ({ signal }) => api<T>(productPath(id), { signal }),
    enabled: allowed, staleTime: 15_000, refetchInterval: 15_000,
  });
  const denied = query.error instanceof ApiError && [401,403,404].includes(query.error.status);
  const valid = query.data && query.data.id === id && visibleCard(query.data) && (user.can_finance || (user.can_publish && isEmployeeBag(query.data)));
  // Keep the last permitted response during a background refresh, but never
  // retain it after an explicit access denial or a change of session/role.
  const data = allowed && !denied && valid ? query.data : undefined;
  const error = !allowed || (query.data && !valid) ? new ApiError("Эта карточка недоступна для вашей роли.",403) : query.error;
  return { ...query, data, error, isPending: allowed && query.isPending };
}
